import React, { useState } from "react";
import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Modal,
    Radio,
    RadioGroup,
    Typography,
    TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const AssetServicesSnapshotModal = (props) => {
    const currentDate = new Date();
    const formatDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;

    const { open, toggleModal, archiveAssetServicesRecord, propertyManagementKey, propertyKey } = props;

    const [managementRetained, toggleManagementRetained] = useState("true");
    const [terminationDate, selectTerminationDate] = useState(formatDate);

    const toggleModalClose = () => {
        toggleModal(false);
    };

    const toggleRadio = (value) => {
        toggleManagementRetained(value);
    };

    const handleSubmit = (propertyManagementKey, propertyKey, managementRetained) => {
        const boolManagementRetained = managementRetained === "true" ? true : false;
        const record = {
            managementRetained: boolManagementRetained,
            terminationDate,
        };
        archiveAssetServicesRecord(propertyManagementKey, record, propertyKey);
        toggleModalClose();
    };

    return (
        <React.Fragment>
            <Modal
                aria-labelledby="asset-services-snapshot-modal"
                aria-describedby="saves a new archive snapshot of the current property management information"
                open={open}
                onClose={toggleModalClose}
            >
                <PaperDiv>
                    <ModalHeader variant="h5">
                        Archive Asset Record?
                    </ModalHeader>
                    <FormContainer>
                        <div>
                            <RetainManagementRadioGroup
                                toggleRadio={toggleRadio}
                                managementRetained={managementRetained}
                            />
                            <DatePicker selectTerminationDate={selectTerminationDate} />
                        </div>
                        <FormSubmitButtons
                            toggleModalClose={toggleModalClose}
                            handleSubmit={() => handleSubmit(propertyManagementKey, propertyKey, managementRetained)}
                        />
                    </FormContainer>
                </PaperDiv>
            </Modal>
        </React.Fragment>
    );
};

const RetainManagementRadioGroup = (props) => {
    const { toggleRadio, managementRetained } = props;
    return (
        <FormControlStyle>
            <FormLabel id="retain-management">Retain management:</FormLabel>
            <RadioGroupStyle
                aria-labelledby="retain-management"
                defaultValue={"true"}
                name="radio-buttons-group"
                value={managementRetained}
                onChange={(e) => {
                    toggleRadio(e.target.value);
                }}
            >
                <FormControlLabel value={"true"} control={<Radio color="primary" />} label="Yes" />
                <FormControlLabel value={"false"} control={<Radio color="primary" />} label="No" />
            </RadioGroupStyle>
        </FormControlStyle>
    );
};

const DatePicker = (props) => {
    const { selectTerminationDate } = props;
    const today = new Date().toISOString().slice(0, 10);
    return (
        <DatePickerContainer>
            <FormLabel>Archive Date:</FormLabel>
            <DatePickerStyle
                id="date"
                type="date"
                defaultValue={today}
                InputProps={{
                    disableUnderline: true,
                    inputProps: { max: today },
                }}
                onChange={(e) => {
                    selectTerminationDate(e.target.value);
                }}
            />
        </DatePickerContainer>
    );
};

const FormSubmitButtons = (props) => {
    const { toggleModalClose, handleSubmit } = props;
    return (
        <React.Fragment>
            <SubmitButtonsContainer>
                <Button variant="contained" color="default" onClick={toggleModalClose}>
                    No
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                    Yes
                </Button>
            </SubmitButtonsContainer>
        </React.Fragment>
    );
};

const SnapshotModal = styled('div')({
  display: "flex",
});

const PaperDiv = styled('div')({
  display: "flex",
  flexDirection: "column",
  background: "white",
  top: "50%",
  left: "50%",
  width: "400px",
  height: "250px",
  transform: "translate(-50%, -50%)",
  position: "absolute",
  alignItems: "center",
  borderRadius: "3px",
  boxShadow: "0 3px 7px rgba(0, 0, 0, 0.3)",
});

const ModalHeader = styled(Typography)({
  alignSelf: "center",
  marginTop: "5%",
});

const FormContainer = styled('div')({
  display: "flex",
  justifyContent: "space-around",
  flexDirection: "column",
  width: "80%",
  height: "90%",
});

const RadioGroupStyle = styled(RadioGroup)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
  justifyContent: "center",
});

const FormControlStyle = styled(FormControl)({
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "center",
});

const DatePickerContainer = styled('form')({
  display: "flex",
  alignItems: "center",
});

const DatePickerStyle = styled(TextField)({
  width: "100%",
});

const SubmitButtonsContainer = styled('div')({
  display: "flex",
  flexDirection: "row",
  alignSelf: "end",
});

export default AssetServicesSnapshotModal;
